const supportedTitles = ['Mr', 'Mrs', 'Miss', 'Ms'];

export default supportedTitles;
